export default {
  headerContent: {
    title: 'Atlas Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Atlas Mutuel Sigorta İş Yeri Sigortası',
    description: {
      title: 'Atlas Sigortası İşyeri (Paket) Sigortası Nedir? ',
      content: [
        'Atlas Sigortası iş yeri sigortası işletmede oluşabilecek yangın, hırsızlık sel ve su baskını başta olmak üzere birçok riske karşı koruma sağlamaktadır.',
        'İş yeri sigortası işletmede oluşacak risklere karşı işletme sahibini koruyarak yeni yatırımlara olanak sunar.'
      ]
    },
    subContent: {
      title: 'Atlas Sigortası İşyeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası teminatları sigortalı isteklerine göre değişmektedir. ',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Atlas Sigorta İşyeri Paket Yangın Sigortası Teminatları:</u></em></strong>',
          subList: [
            'Alçı Tavan Çökmesi',
            'Alternatif İşyeri Masrafları',
            'Cam Kırılması',
            'Deprem',
            'Deprem ECS',
            'Dolu',
            'Duman',
            'Elektronik Cihaz Sigortası (ECS)',
            'Emniyeti Suiistimal',
            'Enkaz Kaldırma',
            'Fırtına',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri, Kötü Niyetli Hareketler, Terör',
            'Hırsızlık',
            'Hukuksal Koruma',
            'İş Durması',
            'İzolasyon Eksikliği Teminatları',
            'Kar Ağırlığı',
            'Kara-Hava Taşıtları Çarpması',
            'Kasa Hırsızlık',
            'Kasa Yangın',
            'Kira Kaybı',
            'Makine Kırılması',
            'Otomatik Bedel Artışı',
            'Sel Su Baskını',
            'Taşınabilir ECS',
            'Taşınan Para',
            'Yangın Mali Sorumluluk',
            'Yangın Söndürme Masrafları',
            'Yangın, Yıldırım, İnfilak',
            'Yeni Yatırımlar',
            'Yer Kayması Teminatını Kapsar.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Atlas Mutuel Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Atlas Sigortası İşyeri Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'İş yeri sigortası işletme sahibi ihtiyaçları ve istekleri doğrultusunda belirlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Paketleri Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Akaryakıt Paket',
            'Otel Paket',
            'Restoran Paket',
            'Oto Servis Paket',
            'Eczane Paket',
            'Ortak Alan Paket'
          ]
        }
      ]
    },
    {
      title: 'Akaryakıt Paket Teminatları Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Pompacı Yanlış Akaryakıt Koyma',
            'Tanka Yanlış Akaryakıt Koyma',
            'Pompacı Hırsızlık',
            'Listesiz MK ve ECS Teminatları',
            'Daha Düşük MK Muafiyeti',
            'Market Emtiası Gıda Bozulması',
            'Tütün - Alkol Emtiası Teminatı',
            'İkmal Hortumu Kopması',
            'Üçüncü Şahıslar Araç Koruma ',
            'Akaryakıt Kaybı Klozu'
          ]
        }
      ]
    },
    {
      title: 'Otel Paket Teminatları Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Müşterilerin Konakladığı Odalardaki Kasalarda Bulunan Kıymetler İçin Yangın & Hırsızlık',
            'Sprinkler Zararları',
            'Bahçe Ağaçları Ve Süs Bitkileri',
            'Ortak Alanlar (Rıhtım, Heykel Vb)',
            'Yakıt Sızması',
            'Kilit Değiştirme Masrafları (Güvenlik Önlemi Amaçlı)',
            'Rönevasyon ve Arızi İnşaat İşleri',
            'Listesiz MK ve ECS Teminatları',
            'Spor Etkinlikleri',
            'Gıda Zehirlenmesi',
            'Garaj Mali Sorumluluk',
            'Valet Parking Teminatı',
            'Kara Ve Deniz Araçları Sorumluluk',
            'Diğer İşletmeler Sorumluluk'
          ]
        }
      ]
    },
    {
      title: 'Restoran Paket Teminatları Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Gıda Zehirlenmesi Klozu',
            'Elektriksel Hasarlara Bağlı Bozulmalar',
            'Mesleki Faaliyetler Sonucu Zararlar',
            'Vale-park Hizmeti Teminatı',
            'Park Halindeki Araçlar',
            'Sprinkler Sızması',
            'Bahçe Ağaçları Ve Süs Bitkileri',
            'Vestiyerdeki Müşteri Eşyaları ',
            'Çocuk Bakımı Sorumluluk',
            'Diğer İşletmeler Sorumluluk',
            'Listesiz MK ve ECS Teminatları',
            'Daha Düşük MK Muafiyeti',
            'Alkol Ve Tütün Emtiası',
            'Açıktaki Muhteviyat'
          ]
        }
      ]
    },
    {
      title: 'Oto Servis Paket Teminatları Nedir?',
      content: [
        {
          paragraph: null,
          subList: ['Deneme Sürüşü', 'Servis İçi Sürüş', 'Liften Düşme']
        }
      ]
    },
    {
      title: 'Eczane Paket Teminatları Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Reçete Küpür Hırsızlığı',
            'İlaç Bozulması Klozu',
            'Nöbet Teminatı Klozu',
            'Raf Ve Vitrin Devrilmesi Klozu',
            'Mesleki Sorumluluk Klozu'
          ]
        }
      ]
    },
    {
      title: 'Ortak Alan Paket Teminatları Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Kazan Dairesi Mesuliyet Teminatı',
            'Kanal Temizleme Giderleri',
            'Rücu Genişletmesi',
            'Bahçe Ağaçları Ve Süs Bitkileri',
            'Yakıt Sızıntısı Teminatı',
            'Sprinkler Zararları',
            'Kazılar Nedeniyle Meydana Gelen Yer Kayması',
            'Park Halindeki Araçlar',
            '3.Şahıs Koruma Teminatı Ek Genişletmeleri',
            'Ortak Alan İçin Sorumluluk Açıklamaları',
            'Sportif Aktiviteler Teminatı Klozu',
            'Oyun Parkı Teminatı Klozu'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortasında Emtea Nedir?',
      content: [
        {
          paragraph:
            'Emtea hukuksal olarak ticarete konu olan mal demektir. İş yeri sigortanızda yer alan emtea da aynı şekilde iş yerinizde bulunan ham madde ve ham maddeden üretilmiş eşyalara denir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'İşyeri sigortası işletmenizde meydana gelebilecek hasarlar sonucunda oluşacak maddi zararları kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası sizi maddi kayıplara karşı koruyarak yeni yatırımlara olanak sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Teminat Dışı Durumlar Neler?',
      content: [
        {
          paragraph:
            'Teminat dışı kalan haller TSB tarafından yayınlanan genel şartlarda yer alan durumlara ek olarak poliçe teminatları arasında yer almayan teminatlardır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası poliçenin ödemesinin tamamlanmasından sonra yürürlüğe girmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigortası İşyeri Sigortası İçin Gerekli Bilgiler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortasının doğru düzenlenebilmesi için kesin olan bilgilere gerek vardır.',
          subList: null
        },
        {
          paragraph: 'İstenen belgeler;',
          subList: [
            'İşletme tüzel kişilik ise işletmenin vergi numarası,',
            'İşletme şahıs şirketi ise işyeri sahibi TC’si,',
            'İş yerinde bulunan cam bedelleri,',
            'İş yeri yangın güvenlik önlemleri,',
            'İş yeri içerisinde bulunan emtea bedelleri,',
            'Dekorasyon ve demirbaş bedelleri,',
            'İş yeri hırsızlık güvenlik önlemleri bilgileri istenmektedir.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigortası Kimler İşyeri Sigortası Yaptırmalıdır?',
      content: [
        {
          paragraph:
            'İş yeri sigortasında her hangi bir kısıtlama bulunmamaktadır. Tüm işletme sahipleri yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Yangın Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Yangın teminatı işletmede oluşacak yangın ve yangın sonucunda oluşan hasarları poliçede belirtilmiş limitler dahilinde karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Hırsızlık Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Hırsızlık teminat işletmede oluşacak emtea, dekorasyon veya değerli eşya çalınması veya çalınmaya teşebbüs edilmesi halinde ortaya çıkan maddi hasarları poliçe limitlerine kadar karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'İş Yeri Sigortası Nasıl Muhasebeleştirilir?',
      content: [
        {
          paragraph:
            'İş yeri sigortanızı muhasebenize ileterek muhasebeleştirebilirsiniz. Bu işlem sonucunda vergi avantajından yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'İş yeri sigortası online, çağrı merkezi veya acente aracılığıyla yapılmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com güvencesi ile iş yeri sigortası satın almak için başvuru formunu doldurabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigortası İşyeri Sigortası Hesaplaması Yapılırken Nelere Dikkat Edilmelidir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası fiyatları iş yerinizde bulunan emtea, dekorasyon ve demirbaş bedellerine göre hesaplanmaktadır. Bu nedenle alınan teklifte yazılı olan bedeller kontrol edilmelidir. Bu bedeller eksik ise sigorta <strong>eksik sigorta</strong> olmaktadır. Hasar döneminde sorun yaşamamak için teminatlar ve limitler ihtiyaçları karşılayacak şekilde hazırlanmalıdır. ',
          subList: null
        },
        {
          paragraph:
            '**Bu durumlarda hasar gerçekleşmesi sonucunda hasarda muafiyet uygulanabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası fiyatları poliçenin içerdiği teminatlarla orantılıdır. Ne kadar yüksek teminat istenirse prim o kadar yükselir. Aynı zamanda teminat ne kadar düşükse fiyatta o kadar düşük olmaktadır. Bu bağlamda net bir fiyat verilememektedir. Sadece prim odaklı düşük teminat almanızda hasar durumunda sorun yaşamanızı veya cebinizden ekstra bütçe çıkmasına neden olur. Bu durumlarla karşılaşmamak için satın alma aşamasında detaylı karşılaştırma yapmalısınız.',
          subList: null
        },
        {
          paragraph:
            'En uygun sigorta sizin ihtiyaçlarınızın tümüne yanıt verebilen sigortadır. En doğru planı bulmak için teklif almanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigortası İşyeri Sigortası Hesaplama Adımları Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası işletme sektörüne göre değişmektedir. Bazı sektörler için risk analizi gerekmektedir. İş yeri sigortası hesaplaması bu risk analizine göre yapılmaktadır. Yalnız diğer sektörler için işletme bilgileri ve işletme içerisinde bulunan emtea, ve özel dekorasyon değerleri girilerek hesaplanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'İşyeri Sigortası Fiyat Online Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph: 'İş yeri sigortanızı online teklif ekranını kullanarak veya başvuru formunu doldurarak 2 farklı şekilde alabilirsiniz. ',
          subList: null
        },
        {
          paragraph: 'Online teklif almak için alokasko.com üzerinden başvuru formu doldurabilir veya <strong>0216 371 67 77</strong> numaralı hattan uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        },
        {
          paragraph: 'İş yeri sigortası hakkında merak ettiğiniz soruları müşteri danışmanlarımıza sorarak öğrenebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
